import { MutationOptions, useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import api from "../../api";

type TData = void;
type TVariables = string;

export function useCancelPaymentMutation(options?: UseMutationOptions<TData, Error, TVariables>) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["cancel-payment"],
    mutationFn: (paymentId: TVariables) => api.payment.cancel(paymentId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["payments"],
      });
    },
    ...options,
   
  });
}
